function Shop() {
  return (
      <main className="container flex-center threepercent-lr-margin wrap">
        <div className="product">
            <img src="./products/alex-lvrs-dKMueUuH5CQ-unsplash.jpg" className="product-img"></img>
          <div className="justify-center buy-button">
            <a href="#" className="no-decoration">Buy</a>
          </div>
        </div>

        <div className="product">
          <img src="./products/agenlaku-indonesia-FoUETBpb6mY-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>

        <div className="product">
          <img src="./products/cristina-matos-albers-Ltv7a5m8i4c-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>

        <div className="product">
          <img src="./products/galina-n-miziNqvJx5M-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>

        <div className="product">
          <img src="./products/giorgio-trovato-p0OlRAAYXLY-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>

        <div className="product">
          <img src="./products/mae-mu-GnWKTJlMYsQ-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>

        <div className="product">
          <img src="./products/oscar-ivan-esquivel-arteaga-ZtxED1cpB1E-unsplash.jpg" className="product-img"></img>
            <div className="justify-center buy-button">
              <a href="#" className="no-decoration">Buy</a>
            </div>
        </div>
      </main>
  );
}

export default Shop;
